export const locale = {
    lang: 'en',
    data: {
        TOOLBAR_NOTIFICATION_USER: {
            EMPTY: 'You have no notifications',
            DATE_TIME: 'HH:mm',
            SEE_ORDER: 'View order',
            SEE_ORDER_RATING: 'View rating',
            SEE_ORDER_APPROVAL: 'View estimate',
            SEE_CUSTOMER_RELATIONSHIP: 'View task',
            SEE_PRODUCT: 'View product',
            SEE_INVENTORY_ORDER: 'View purchase',
        },
    },
};
